<template>
    <div class="c-table__search">
        <c-form-element :icon="true">
            <div class="c-form-element__icon c-form-element__icon--before color-medium-gray">
                <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M5 11c0-3.309 2.691-6 6-6s6 2.691 6 6-2.691 6-6 6-6-2.691-6-6m15.707 8.293-3.395-3.396C18.365 14.543 19 12.846 19 11c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8c1.846 0 3.543-.635 4.897-1.688l3.396 3.395c.195.195.451.293.707.293.256 0 .512-.098.707-.293a.9989.9989 0 0 0 0-1.414" id="search"/></defs><use fill="currentColor" fill-rule="nonzero" xlink:href="#search"/></svg>
            </div>
            <input type="text" name="search" :placeholder="placeholder" @input="$emit('input', $event.target.value)" />
        </c-form-element>
    </div>
</template>

<script>
import CFormElement from '@components/form/Element';

export default {
    components: { CFormElement },
    props: {
        placeholder: {
            type: String
        }
    }
}
</script>
